import React, { useEffect } from 'react';
import { View, Text, Linking, Platform } from 'react-native';
import * as SplashScreen from 'expo-splash-screen';
import Toast from 'react-native-toast-message';
import SolidButton from './SolidButton';
import { PatternBackground } from './Backgrounds';
import { StyleSheet } from 'react-native-unistyles';
import Unicon from './Unicon';

// iOS App Store URL — use https:// so iOS auto-routes to the App Store app
// without needing itms-apps in LSApplicationQueriesSchemes. See CHURCH-APP-17G.
const IOS_APP_STORE_URL = 'https://apps.apple.com/app/id6475107748';
const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.invendev.chmsnativeapp';

const UpdateRequiredScreen = ({ currentVersion, minimumVersion }) => {
    useEffect(() => {
        SplashScreen.hide();
    }, []);

    const handleUpdate = () => {
        const url = Platform.OS === 'ios' ? IOS_APP_STORE_URL : ANDROID_PLAY_STORE_URL;
        Linking.openURL(url).catch(() => {
            Toast.show({ type: 'error', text2: 'Unable to open the App Store. Please update Reach from the App Store manually.' });
        });
    };

    return (
        <View style={styles.container}>
            <PatternBackground />

            <Unicon name="arrow-up-circle-outline" size={48} library="ionicon" colorVariant="primary" style={styles.icon} />
            <Text style={styles.title}>Update Required</Text>
            <Text style={styles.message}>
                You&apos;re running version {currentVersion}. Please update to version {minimumVersion} or later to continue using Reach.
            </Text>
            <SolidButton text="Update Now" width={200} onPress={handleUpdate} type="primary" />
        </View>
    );
};

const styles = StyleSheet.create(({ colors, fonts }) => ({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        padding: 32,
    },
    icon: {
        marginBottom: 16,
    },
    title: {
        color: colors.text,
        fontSize: 32,
        fontFamily: fonts.heading,
        marginBottom: 12,
    },
    message: {
        marginBottom: 32,
        color: colors.textSecondary,
        fontSize: 16,
        fontFamily: fonts.body,
        textAlign: 'center',
    },
}));

export default UpdateRequiredScreen;
